import { render, staticRenderFns } from "./BookingIndex.vue?vue&type=template&id=4d221688&scoped=true"
import script from "./BookingIndex.vue?vue&type=script&lang=js"
export * from "./BookingIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d221688",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4d221688')) {
      api.createRecord('4d221688', component.options)
    } else {
      api.reload('4d221688', component.options)
    }
    module.hot.accept("./BookingIndex.vue?vue&type=template&id=4d221688&scoped=true", function () {
      api.rerender('4d221688', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/goods_activity/booking/BookingIndex.vue"
export default component.exports